import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'red',
        date: {
          year: 2011,
          month: 12,
          day: 28,
        },
      },
      {
        color: 'red',
        date: {
          year: 2012,
          month: 3,
          day: 6,
        },
      },
      {
        color: 'red',
        date: {
          year: 2012,
          month: 7,
          day: 21,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 1,
          day: 31,
        },
      },
      {
        color: 'red',
        date: {
          year: 2014,
          month: 12,
          day: 31,
        },
      },
      {
        color: 'red',
        date: {
          year: 2015,
          month: 3,
          day: 2,
        },
      },
      {
        color: 'red',
        date: {
          year: 2016,
          month: 8,
          day: 22,
        },
      },
      {
        color: 'red',
        date: {
          year: 2019,
          month: 1,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2019,
          month: 11,
          day: 22,
        },
      },
      {
        color: 'red',
        date: {
          year: 2020,
          month: 4,
          day: 24,
        },
      },
      {
        color: 'red',
        date: {
          year: 2020,
          month: 6,
          day: 23,
        },
      },
      {
        color: 'red',
        date: {
          year: 2020,
          month: 12,
          day: 2,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 4,
          day: 25,
        },
      },
      {
        color: 'red',
        date: {
          year: 2015,
          month: 3,
          day: 2,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 8,
          day: 8,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'red',
        date: {
          year: 2011,
          month: 12,
          day: 28,
        },
      },
      {
        color: 'red',
        date: {
          year: 2012,
          month: 3,
          day: 6,
        },
      },
      {
        color: 'red',
        date: {
          year: 2012,
          month: 7,
          day: 21,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 1,
          day: 31,
        },
      },
      {
        color: 'red',
        date: {
          year: 2014,
          month: 12,
          day: 31,
        },
      },
      {
        color: 'red',
        date: {
          year: 2015,
          month: 3,
          day: 2,
        },
      },
      {
        color: 'red',
        date: {
          year: 2016,
          month: 8,
          day: 22,
        },
      },
      {
        color: 'red',
        date: {
          year: 2019,
          month: 1,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2019,
          month: 11,
          day: 22,
        },
      },
      {
        color: 'red',
        date: {
          year: 2020,
          month: 4,
          day: 24,
        },
      },
      {
        color: 'red',
        date: {
          year: 2020,
          month: 6,
          day: 23,
        },
      },
      {
        color: 'red',
        date: {
          year: 2020,
          month: 12,
          day: 2,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 4,
          day: 25,
        },
      },
      {
        color: 'red',
        date: {
          year: 2015,
          month: 3,
          day: 2,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 8,
          day: 8,
        },
      },
    ],
  },
};
